import * as Yup from "yup";

const PlayerMemoSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
});

export default PlayerMemoSchema;
